import { FlaskConical } from "lucide-react";
import { useAuth } from "@/shared/auth/auth.context";
import { Button } from "@/shared/components/ui/button";
import { useActiveWorkspace } from "@/shared/hooks/use-active-workspace";

export function DemoWorkspaceBanner() {
  const auth = useAuth();
  const { workspace, setWorkspace, isResolved } = useActiveWorkspace();
  const activeWorkspace = isResolved
    ? (auth.workspaces.find((item) => item.id === workspace.id) ?? null)
    : null;
  const primaryWorkspace =
    auth.workspaces.find((item) => !item.isReadOnly && !item.isDemo) ??
    auth.workspaces.find((item) => !item.isReadOnly) ??
    null;

  if (auth.isLoading || !isResolved || !activeWorkspace?.isReadOnly) return null;

  return (
    <div className="border-b border-border bg-surface-subtle/95 px-4 py-3 backdrop-blur-md md:px-8">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <div className="mt-0.5 rounded-full bg-muted p-2 text-text-brand">
            <FlaskConical className="size-4" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground">
              You're exploring the read-only sample workspace.
            </p>
            <p className="text-sm text-text-secondary">
              Use it to tour goals, feedback, pulse dashboards, and reporting with realistic data.
              Any create, edit, invite, or response actions stay disabled here.
            </p>
          </div>
        </div>
        {primaryWorkspace != null ? (
          <Button variant="outline" size="sm" onClick={() => setWorkspace(primaryWorkspace.id)}>
            Switch to {primaryWorkspace.name}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
